import { APP_DISPLAY_NAME } from '../appMeta';

/** 브라우저 탭·새 탭 플레이스홀더 제목을 앱 표시명으로 맞춘다. */
export function applyAppDocumentTitle(doc: Document = document): void {
  doc.title = APP_DISPLAY_NAME;
}

/**
 * 설치 웹앱(standalone)에서 새 창이 브라우저가 아니라 앱 창으로 열리게 한다.
 * `about:blank`는 PWA 범위 밖이라 Chrome이 일반 브라우저로 열고,
 * `window.open(url, '_blank', 'noopener')`처럼 feature 문자열을 주면 팝업으로 빠져 나간다.
 */
export function openSameOriginWindow(url: string): Window | null {
  try {
    const w = window.open(url, '_blank');
    if (!w) return null;
    try {
      w.opener = null;
    } catch {
      /* ignore */
    }
    return w;
  } catch {
    return null;
  }
}

export type AppWindowPlaceholderStatus = 'ai-generating';

export function buildAppWindowPlaceholderUrl(status?: AppWindowPlaceholderStatus): string {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const path = `${base}/app-window`;
  const origin = typeof window !== 'undefined' && window.location?.origin ? window.location.origin : '';
  const url = origin ? `${origin}${path}` : path;
  if (status === 'ai-generating') return `${url}?status=ai-generating`;
  return url;
}

/** 클릭 직후 팝업 차단을 피하려고 먼저 같은 출처 창을 연다. */
export function openBlankTabWithAppTitle(status?: AppWindowPlaceholderStatus): Window | null {
  return openSameOriginWindow(buildAppWindowPlaceholderUrl(status));
}
